import logo from './logo.png';

export const settings = {
    "title": "Genius Cloud",
    "apiUrl": "https://api.kitchenlab.geniuscloud.it/api",
    "ckdPath": "https://api.kitchenlab.geniuscloud.it/",
    "tinyKey": "uxd8thxx2a96p0tne20wyfcdx7zvpyprm38j5q5w9qqauy2p",
    "googleMapKey": "AIzaSyDwVSRwXezXuTLG8-VAe1KfNKo7zLPlYJQ",
    //"googleMapKey": "AIzaSyB0JItfx2zvDnKkmxIBt_wru36tOVcx1iM",
    "config": {
        "limit": 50,
        "sortingField": 'id',
        "sortingOrder": 'desc'
    },
    "configEntity": {
        "customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "supplier": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "sales_agent": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        }
    },
    "theme": {
        "siderbarIconColor": 'rgba(233,236,239,.5)'
    },
    "logo": logo,
    "data_print": {
        "name": 'Kitchen Lab Srls',
        "address": 'Circonvallazione Gianicolense 273 00151 Roma (RM)',
        "phone": 'Tel: 06 99709124',
        "fax": '',
        "email": 'Email: kitchenlabsrls@gmail.com',
        "iva": 'P.IVA: 17319621003',
        "cf": 'C.F.: 17319621003',
        "website": 'Sito Web: www.arredo3gianicolense.it',
    },
    "stampe" : {
       "arredatore": false, 
       "sconto": true, 
       "listino": true, 
       "condVendita": false, 
       "firmaVenditore": false
    },
    "dati_pagamento": {
        "iban": "IT42J0103003207000003239964",
        "banca": "Banca Monte dei Paschi di Siena Spa",
        "intestatario": "Kitchen Lab Srls",
    },
    "iva_label": 'inclusa',
    "iva_esclusa": false,
    "sconti": false,
    "usingCache": false,
    "fatturazione": false
}